import React, { PureComponent } from 'react';
import { PrimaryButton } from 'appSrc/components/UI';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import Edit from 'appSrc/components/Icons/Edit';
import { FormTextField, FormToggle, FormTextArea } from 'appSrc/components/UI/ReduxForm';
import style from './styles/style.module.css';
import defaultProfileIcon from 'appSrc/assets/img/profile.svg';
import CategorySelectModal from 'appSrc/AdminPanel/pages/Modals/Category/Select';


class BrandForm extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            selectedImage: props.initialValues.cover_image,
            selectedLogo: props.initialValues.logo,
            categories: props.initialValues.categories || [],
        };
    }

    cropFinish = ( imageData ) => {
        this.setState( {
            selectedImage: imageData,
        } );
        if( imageData != null ) {
            this.props.changeFieldValue( 'cover_image', imageData );
        }
    }

    cropFinishLogo = ( imageData ) => {
        this.setState( {
            selectedLogo: imageData,
        } );
        if( imageData != null ) {
            this.props.changeFieldValue( 'logo', imageData );
        }
    }

    updateCategories = ( { checked, data } ) => {
        this.props.changeFieldValue( 'categories', data );
        this.setState( {
            categories: data,
            showCategorySelect: false,
        } );
    }
    
    submitHandler = ( values ) => {
        var data = { ...values };
        data.cover_image = this.state.selectedImage;
        data.logo = this.state.selectedLogo;
        this.props.onSubmit( data );
    }

    render() {
        const { handleSubmit } = this.props;
        const { selectedImage, selectedLogo, categories } = this.state;

        return (
            <div>
                <Form className={ style.brandForm }
                onSubmit={ handleSubmit( this.submitHandler ) }>
                    <div className={ style.topLevel }>

                        <div>Cover Image</div>
                        <div className={ style.imageWrapper }>
                            <ImageCropModalWrapper
                            aspectRatio={ '16/9' }
                            onFinish={ this.cropFinish }>
                                <div>
                                    <img src={ selectedImage || defaultProfileIcon } />
                                    <span className={ style.editWrapper }><Edit style={ { display: 'inline-block' } } /></span>
                                </div>
                            </ImageCropModalWrapper>
                        </div>

                        <div>Logo</div>
                        <div className={ style.imageWrapper }>
                            <ImageCropModalWrapper
                            aspectRatio={ '1' }
                            onFinish={ this.cropFinishLogo }>
                                <div>
                                    <img src={ selectedLogo || defaultProfileIcon } />
                                    <span className={ style.editWrapper }><Edit style={ { display: 'inline-block' } } /></span>
                                </div>
                            </ImageCropModalWrapper>
                        </div>

                        <div className={ style.detailsWrapper }>
                            <Field
                            id="name"
                            name="name"
                            label="Name"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="description"
                            name="description"
                            component={ FormTextArea }
                            label="Description"
                            fullWidth />

                            <Field
                            id="site_url"
                            name="site_url"
                            label="Site URL"
                            component={ FormTextField }
                            fullWidth />

                            <div className={ style.categoriesField } >
                                <div className={ style.fieldTitle }>Categories:</div>
                                <p onClick={ () => { this.setState( { showCategorySelect: true } ); } }>{ categories.map( category => category.name ).join( ', ' ) }</p>
                            </div>

                            { this.state.showCategorySelect &&
                                <CategorySelectModal initialValues={ this.props.initialValues.categories ? this.props.initialValues.categories : [] }
                                onSubmit={ this.updateCategories }
                                closeHandler={ () => { this.setState( { showCategorySelect: false } ); } } />
                            }

                            <Field
                            id="slug"
                            name="slug"
                            label="Embed Slug"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="embed"
                            name="embed"
                            label="Embed"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } }
                            />

                            <Field
                            id="cc"
                            name="cc"
                            label="Captions"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } }
                            />

                            <Field
                            id="published"
                            name="published"
                            label="Published"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } }
                            />

                            <Field
                            id="deactivated"
                            name="deactivated"
                            label="Deactivated"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } }
                            />

                            <PrimaryButton
                            label="Submit"
                            fullWidth
                            type="submit"
                            style={ { marginTop: '45px' } }/>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

BrandForm.defaultProps = {
    initialValues: {},
};

BrandForm = reduxForm( {
    form: 'BrandForm',
} )( BrandForm );

const mapStateToProps = ( state ) => {
    return { };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'BrandForm', field, value ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( BrandForm );
